import axios from './axiosInstance';

export const addModality = async ({
  title,
  summary,
  details
}) => {
  try{
    const response = await axios({
      url : '/add-modality',
      method : 'POST',
      data : {
        title : title,
        summary : summary,
        details : details
      }
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const listModalities = async ({
  page,
  limit,
  search
}) => {

  let params = {};

  if(page !== null){
    params.page = page
  }
  if(limit){
    params.limit = limit
  }
  if(search){
    params.search = search
  }
  try{
    const response = await axios({
      url : '/list-modalities',
      method : 'GET',
      params : params
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const updateModality = async ({
  data,
  id
}) => {

  try{
    const response = await axios({
      url : `/update-modality/${id}`,
      method : 'PUT',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const getModality = async ({
  id
}) => {

  try{
    const response = await axios({
      url : `/get-modality/${id}`,
      method : 'GET'
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}